import colors from 'vuetify/es5/util/colors'

export default {
    primary: "#9e9e9e",
    panel: "#9e9e9e",
    topPanel: "#9e9e9e",
    iconColor: '#9e9e9e',
    secondary: '#9e9e9e',
    accent: '#9e9e9e',
    error: '#9e9e9e',
    warning: '#9e9e9e',
    info: '#9e9e9e',
    success: '#9e9e9e',
}   


// WEBPACK FOOTER //
// ./src/theme.js